import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Users, DollarSign } from 'lucide-react';
export function Sidebar() {
  return <div className="w-60 bg-slate-700 text-white flex flex-col h-full" data-id="element-205">
      <div className="p-4 flex items-center gap-2 border-b border-slate-600" data-id="element-206">
        <DollarSign size={24} data-id="element-207" />
        <h1 className="text-xl font-semibold" data-id="element-208">Cashflow Audit Pro</h1>
      </div>
      <nav className="flex-1 py-4" data-id="element-209">
        <NavLink to="/" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-210">
          <Home size={20} data-id="element-211" />
          <span data-id="element-212">Home</span>
        </NavLink>
        <NavLink to="/player1" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-213">
          <Users size={20} data-id="element-214" />
          <span data-id="element-215">Player 1</span>
        </NavLink>
        <NavLink to="/player2" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-216">
          <Users size={20} data-id="element-217" />
          <span data-id="element-218">Player 2</span>
        </NavLink>
        <NavLink to="/player3" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-219">
          <Users size={20} data-id="element-220" />
          <span data-id="element-221">Player 3</span>
        </NavLink>
        <NavLink to="/player4" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-222">
          <Users size={20} data-id="element-223" />
          <span data-id="element-224">Player 4</span>
        </NavLink>
        <NavLink to="/player5" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-225">
          <Users size={20} data-id="element-226" />
          <span data-id="element-227">Player 5</span>
        </NavLink>
        <NavLink to="/player6" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-228">
          <Users size={20} data-id="element-229" />
          <span data-id="element-230">Player 6</span>
        </NavLink>
        <NavLink to="/player7" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-231">
          <Users size={20} data-id="element-232" />
          <span data-id="element-233">Player 7</span>
        </NavLink>
        <NavLink to="/player8" className={({
        isActive
      }) => `flex items-center gap-3 px-4 py-3 ${isActive ? 'bg-slate-600' : 'hover:bg-slate-600'}`} data-id="element-234">
          <Users size={20} data-id="element-235" />
          <span data-id="element-236">Player 8</span>
        </NavLink>
      </nav>
    </div>;
}